import { RoleSlugEnum } from "generated/graphql-types"

export class AuthorizationError extends Error {
	public name = "AuthorizationError"

	constructor(allowedRoles: RoleSlugEnum[]) {
		super(`Role must be one of the following: ${allowedRoles.join(", ")}`)
	}
}
